import {useDispatch, useSelector} from 'react-redux'
import {isMexico, useBuildingTypeEPQ, useInputDataState, useIsPR, useLabels} from '../../functions'
import {writeExtraChoices} from '../../state/customerAsyncActions'
import {Col, Form, Row} from 'react-bootstrap'
import {HowManyUsers} from './general'
import {FormCheck, FormLabel} from '../Utilities/Form'

export const FeaturesBusiness = () => {
    const labels = useLabels()
    const [satPackageChoice, setSatPackageChoice] = useInputDataState('satPackageChoice')
    const [useHomeBusinessChoice, setUseHomeBusinessChoice] = useInputDataState('useHomeBusinessChoice')
    const program = useSelector(state => state.customer.data.program)
    const [someonePlayVideoGames, setSomeonePlayVideoGames] = useInputDataState('someonePlayVideoGames')
    const [securityUsed, setSecurityUsed] = useInputDataState('securityUsed')
    const [buildingType, setBuildingType] = useInputDataState('buildingType')
    const dispatch = useDispatch()
    const isPR1 = useIsPR()
    const isBuildingTypeEPQ = useBuildingTypeEPQ()

    const onSatPackageChoice = (e) => {
        setSatPackageChoice(e)
        dispatch(writeExtraChoices())
    }


    let packageChoicesComponent
    let packageOnlineVideoGamesComponent
    let packageSecurityUsedComponent
    let businessBuildingTypeComponent
    let useHomeBusinessQuestionComponent

    if (isMexico(program)) {
        useHomeBusinessQuestionComponent = <Row className="mb-3">
            <Col>
                <FormLabel bold={true}>{labels.useHomeBusinessQuestion}</FormLabel>
                <FormCheck type="radio" name="useHomeBusinessChoice" checked={useHomeBusinessChoice === 'Home'}
                           label="Casa" value="Home" onChange={setUseHomeBusinessChoice}/>
                <FormCheck type="radio" name="useHomeBusinessChoice" checked={useHomeBusinessChoice === 'Office'}
                           label="Oficina (Pyme o emprendimiento)" value="Office" onChange={setUseHomeBusinessChoice}/>
            </Col>
        </Row>
    } else if (isPR1) {
        packageChoicesComponent = <Row className="mb-3">
            <Col>
                <FormLabel bold={true}>{labels.satPackageChoice}</FormLabel>
                <FormCheck type="radio" name="satPackageChoice" checked={satPackageChoice === labels.recommend1And2}
                           label={labels.recommend1And2} value={labels.recommend1And2} onChange={onSatPackageChoice}/>
                <FormCheck type="radio" name="satPackageChoice" checked={satPackageChoice === labels.recommend3And4}
                           label={labels.recommend3And4} value={labels.recommend3And4} onChange={onSatPackageChoice}/>
                <FormCheck type="radio" name="satPackageChoice" checked={satPackageChoice === labels.recommend5And10}
                           label={labels.recommend5And10} value={labels.recommend5And10} onChange={onSatPackageChoice}/>
                <FormCheck type="radio" name="satPackageChoice" checked={satPackageChoice === labels.recommend11And15}
                           label={labels.recommend11And15} value={labels.recommend11And15}
                           onChange={onSatPackageChoice}/>
            </Col>
        </Row>
    } else if (!isMexico(program) && !isPR1) {
        if (isBuildingTypeEPQ) {
            businessBuildingTypeComponent = <Row className="mb-3">
                <Col>
                    <Form.Group>
                        <FormLabel bold={true} required={true}>{labels.businessBuildingType}</FormLabel>
                        <FormCheck value="Commercial Building" label="Commercial Building"
                                   checked={buildingType === 'Commercial Building'} onChange={setBuildingType}/>
                        <FormCheck value="Residential Location" label="Home"
                                   checked={buildingType === 'Residential Location'} onChange={setBuildingType}/>
                    </Form.Group>
                </Col>
            </Row>
        }

        packageSecurityUsedComponent = <Row className="mb-3">
            <Col md={6}>
                <FormLabel required={true}>{labels.securityUsedQuestion}</FormLabel>
                <FormCheck type="radio" label={labels.yesOption} value="Y" checked={securityUsed === 'Y'}
                           onChange={setSecurityUsed}/>
                <FormCheck type="radio" label="No" value="N" checked={securityUsed === 'N'}
                           onChange={setSecurityUsed}/>
            </Col>
        </Row>

    }


    packageOnlineVideoGamesComponent = <Col md={6}>
        <Form.Group>
            <FormLabel bold={true}>{labels.onlineVideoGameQuestion}</FormLabel>
            <FormCheck type="radio" label={labels.yesOption} value="Y" checked={someonePlayVideoGames === 'Y'}
                       onChange={setSomeonePlayVideoGames}/>
            <FormCheck type="radio" label="No" value="N" checked={someonePlayVideoGames === 'N'}
                       onChange={setSomeonePlayVideoGames}/>
        </Form.Group>
    </Col>

    return <>

        {packageChoicesComponent}

        <Row className="mb-3">
            <HowManyUsers md={6}/>
        </Row>
        {useHomeBusinessQuestionComponent}
        {businessBuildingTypeComponent}
        {packageOnlineVideoGamesComponent}

        {packageSecurityUsedComponent}


    </>
}

